import {
    FETCH_FEATURE_SETTINGS_FAILED,
    FETCH_FEATURE_SETTINGS_SUCCEEDED,
} from './index'

export const appFeatures = (state = {}, action) => {
    switch (action.type) {
        case FETCH_FEATURE_SETTINGS_FAILED:
            return {
                ...state,
                error: action.errors,
            }
        case FETCH_FEATURE_SETTINGS_SUCCEEDED:
            return {...action.payload.result.featureSettings}
        default:
            return { ...state }
    }
}